/**
 * Requires
 */

import $ from 'jquery'

/**
 * Initialisation
 */

export function initialise() {
  if (window.disableAutoTargetLinks) {
    return
  }

  // Open external links and PDFs in new window
  $('a, area')
    .filter(function () {
      var href = $(this).attr('href')
      return (
        href &&
        !this.target &&
        ((href.indexOf(window.location.hostname) == -1 && href.match(/^https?/i)) || href.match(/\.pdf$/i))
      )
    })
    .attr('target', '_blank')
    .attr('rel', 'noopener noreferrer')
}
